import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const tabs = [
    { path: "/home", icon: "ri-dashboard-line", activeIcon: "ri-dashboard-fill", label: t("nav.home") },
    { path: "/payments", icon: "ri-bill-line", activeIcon: "ri-bill-fill", label: t("nav.payments") },
    { path: "/payments/add", icon: "ri-add-circle-line", activeIcon: "ri-add-circle-fill", label: t("nav.add"), isCenter: true },
    { path: "/analytics", icon: "ri-pie-chart-line", activeIcon: "ri-pie-chart-fill", label: t("nav.analytics") },
    { path: "/profile", icon: "ri-user-line", activeIcon: "ri-user-fill", label: t("nav.profile") },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-slate-100">
      <div className="grid grid-cols-5 w-full max-w-[375px] mx-auto h-16">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const isCenter = tab.isCenter;

          if (isCenter) {
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                className="flex flex-col items-center justify-center gap-0.5 relative"
              >
                <div className="w-12 h-12 -mt-4 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg shadow-indigo-500/30 active:scale-95 transition-transform">
                  <i className={`${tab.icon} text-white text-2xl`}></i>
                </div>
                <span className="text-[0.625rem] text-slate-400 mt-0.5">{tab.label}</span>
              </button>
            );
          }

          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center gap-0.5"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i
                  className={`${
                    isActive ? tab.activeIcon : tab.icon
                  } text-lg ${
                    isActive ? "text-indigo-600" : "text-slate-400"
                  }`}
                ></i>
              </div>
              <span
                className={`text-[0.625rem] ${
                  isActive ? "text-indigo-600 font-medium" : "text-slate-400"
                }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}